import React from 'react'
import { CSStyles } from '../../useGenerateLayerCSS'
import { CodeBlock } from './Code.styles'

export interface CodeProps {
  styles: CSStyles
}

export const Code = ({ styles }: CodeProps) => {
  return <CodeBlock {...{ styles }} />
}
